module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/price-config-inactive.db687f2d.svg";